import {Component, Input, OnInit} from '@angular/core';
import {GROUP_TYPE_CAMP} from "../../../constants";
import {StudentSelfGroup} from "../../../../types/interfaces";
import {TranslocoService} from "@jsverse/transloco";

@Component({
    selector: 'app-student-group',
    templateUrl: './student-group.component.html',
    styleUrls: ['./student-group.component.scss'],
})
export class StudentGroupComponent implements OnInit {

    @Input() group: StudentSelfGroup;
    @Input() class: string = '';
    @Input() lessonStart: boolean = false;
    @Input() isCurrent: boolean = false;
    @Input() isFuture: boolean = false;
    @Input() isPast: boolean = false;
    @Input() hideEducationMaterials: boolean = false;

    constructor(private translocoService: TranslocoService) {
    }

    ngOnInit() {
    }

    getTranslatedTitle(key: string): string {
        const translation = this.translocoService.translate(key);
        console.log(translation);
        return translation !== key ? translation : key;
    }


    protected readonly GROUP_TYPE_CAMP = GROUP_TYPE_CAMP;
}
